module.exports = __webpack_public_path__ + "media/images/service-2-50219e9b7bb6c7d8ac736d943a95138a.png";